<template>
  <div>
    <div id="loginbox">
      <img src="@/assets/img/YonghuiSync/post.png" />

      <van-form class="lform" ref="form" @submit="submit">
        <van-field
          class="lform-input phone"
          placeholder="请输入手机号"
          v-model="form.phone"
          name="phone"
          :rules="[
            {
              required: true,
              validator: val => /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val),
              message: '请填写正确的手机号'
            }
          ]"
        />
        <van-field
          class="lform-input yzm"
          placeholder="请输入验证码"
          v-model="form.code"
          :rules="[
            {
              required: true,
              message: '请输入验证码'
            }
          ]"
        >
          <template #button>
            <div class="cdown" v-if="!time" @click="sendCode">发送验证码</div>
            <van-count-down
              class="cdown"
              v-else
              :time="time"
              @finish="time = 0"
            />
          </template>
        </van-field>
        <van-button
          class="submit"
          :loading="loading"
          loading-text="兑换中..."
          native-type="submit"
        >
          前往兑换
        </van-button>
      </van-form>
      <!-- 该链接内所有的说明以及样式均为电商运营部定制，虽然业务逻辑通用，但是行业合作部的业务属性不适用该页面样式，故需要更改页面内部分文字说明，并且生成新的链接供行业合作部使用 -->
      <!-- type:1 行业合作部 -->
      <div class="prompt important" v-show="![1].includes(+$route.query.type)">
        <div class="prompt-title">
          <img src="@/assets/img/YonghuiSync/prompt_icon.png" alt="" />
          <span class="text">防骗公告</span>
        </div>
        <div class="content">
          <p class="err">
            兑换后卡券不可退换、不可挂失，请妥善保管卡券信息，切勿发给他人，谨防泄露！
          </p>
          <p>
            本店没有小号旺旺，没有QQ、微信客服，从不刷信誉、做任务，从未委托任何机构或个人以“刷单返利”、“刷信誉”等方式购买商品，凡是要求提供手机验证码、远程共享屏幕都是为了骗你卡密，请广大消费者提高警惕，谨防上当受骗！
          </p>
        </div>
      </div>
      <div class="prompt">
        <div class="prompt-title">
          <img src="@/assets/img/YonghuiSync/tips.png" alt="" />
          <span class="text">兑换说明</span>
        </div>
        <div class="content">
          <p>
            1、接收验证码的手机号请填写您本人手机号，兑换前请确保页面所有信息填写正确，兑换后不支持退款！
          </p>
          <p v-if="[1].includes(+$route.query.type)">
            2、如遇订单量大或网络拥堵，券码出库可能会有所延迟，建议您耐心等待,若有疑问可联系4006627299。
          </p>
          <p v-else>
            2、如遇订单量大或网络拥堵，券码出库可能会有所延迟，建议您耐心等待若有疑问可咨询店铺在线客服。
          </p>
        </div>
      </div>
    </div>
    <!-- 人脸验证弹框 -->
    <van-dialog
      v-model="showFaceAuth"
      title=""
      confirmButtonText="进行人脸验证"
      @confirm="submitFaceAuth"
    >
      <div class="face-auth-form">
        <van-field
          v-model="authForm.name"
          label="姓名："
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-field
          v-model="authForm.certNo"
          label="身份证："
          placeholder="请输入身份证号"
          :rules="[
            { required: true, message: '请输入身份证号' },
            {
              pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2]\d|3[0-1])\d{3}(\d|X|x)$/,
              message: '请输入正确的身份证号'
            }
          ]"
        />
        <van-field
          v-model="authForm.phone"
          label="手机号："
          disabled
          placeholder="请输入手机号"
          :rules="[
            { required: true, message: '请输入手机号' },
            {
              pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
              message: '请输入正确的手机号'
            }
          ]"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  syncVerifyFace,
  sendVerifyCodeForFaceSync,
  alipayCertification,
  queryCertification,
  checkForSyncLink
} from '@/api/fsl.js'
export default {
  data() {
    return {
      time: 0,
      loading: false,
      form: {
        phone: null,
        code: null,
        redeCodeNo: null // 真实
      },
      showFaceAuth: false,
      authForm: {
        name: '',
        certNo: '',
        phone: ''
      },
      faceLoading: false,
      certifyId: undefined // 支付宝认证ID
    }
  },
  mounted() {
    // 查询人脸认证结果
    this.getCertificationStatus()
  },
  methods: {
    async submit() {
      try {
        this.loading = true
        const { code, data, message } = await syncVerifyFace({
          ...this.form,
          redeemCodePageType: 16,
          pageTypeMatchFlag: false
        })
        this.loading = false
        switch (code) {
          case 0:
            this.$router.push({
              path: '/fslList',
              query: {
                token: data.token,
                redeCodeNo: data.redeCodeNo
              }
            })
            break
          case 10004:
            // 人脸认证
            this.faceAuth()
            break
          case 2:
            this.$router.push({
              path: '/fslCrowded'
            })
            break
          case 3:
            this.$router.push({
              path: '/fslOutStock'
            })
            break
          default:
            this.$toast.fail({
              message: message
            })
            break
        }
      } catch (error) {
        this.loading = false
      }
    },
    sendCode() {
      this.$refs.form.validate('phone').then(async () => {
        const form = this.form
        const { code, message } = await sendVerifyCodeForFaceSync({
          phone: form.phone,
          redeCodeNo: form.redeCodeNo,
          domain: window.location.hostname
        })
        if (code === 0) {
          this.time = 60000
        } else if (code === 10004) {
          this.faceAuth()
        } else {
          this.$toast.fail({
            message: message
          })
        }
      })
    },
    // 人脸认证弹框
    async faceAuth() {
      await this.$dialog.confirm({
        message: '该手机号暂未进行人脸实名认证，请认证后兑换'
      })
      this.authForm.phone = this.form.phone
      this.showFaceAuth = true
    },
    // 同步链接兑换码-校验接口 获取真实兑换码 如果返回token则兑换过所以直接跳转
    async loadData() {
      const param = {
        redeemCodePageType: 16,
        redeCodeNoPwd: this.$route.params.code,
        pageTypeMatchFlag: true
      }
      const { code, data, message } = await checkForSyncLink(param)
      this.form.redeCodeNo = data?.redeCodeNo
      if (code !== 0) {
        this.$toast.fail({
          message: message
        })
      }
      if (data?.token) {
        this.$router.push({
          name: 'fslList',
          query: {
            token: data.token,
            redeCodeNo: data.redeCodeNo
          }
        })
      }
    },
    // 查询认证结果
    async getCertificationStatus() {
      const queryPhone = this.$route.query.phone
      // 获取真实兑换码
      await this.loadData()
      // 不是支付宝认证回调回来的就不进行认证结果查询
      if (!queryPhone) return
      this.form.phone = queryPhone
      // 手机号输入完11位再，获取支付宝认证状态
      const { data } = await queryCertification({
        phone: this.form.phone,
        bizType: 1, // 业务类型 1人脸认证兑换码
        certifyId: this.certifyId
      })
      // certifyStatus 认证状态 0待认证 1成功 2失败 3认证中 4过期
      if (data?.certifyStatus === 0) {
        this.faceAuth()
      } else if (data?.certifyStatus === 2) {
        this.$toast.fail('认证失败，请重试')
      }
    },
    // 提交认证信息
    async submitFaceAuth() {
      try {
        this.faceLoading = true
        const baseUrl = window.location.href.split('#')[0] // 哈希前面url部分
        const redeCodeNoPwd = encodeURIComponent(this.$route.params.code)
        const { code, data } = await alipayCertification({
          ...this.authForm,
          bizType: 1, // 业务类型 1人脸认证兑换码
          returnUrl: `${baseUrl}#/fsl/${redeCodeNoPwd}?phone=${this.form.phone}` // 认证回调地址
        })
        if (code === 0) {
          this.showFaceAuth = false
          this.certifyId = data.certifyId
          // 跳转支付宝去认证
          window.location.href = data.certifyUrl
        }
      } finally {
        this.faceLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/style/YonghuiSync.less';
</style>
